import React from "react"
import { withApi } from "@tencent/react-aio"
import { FormGroup } from "@tencent/spaui"
import MessageBox from "@/components/MessageBox"
import _ from "lodash"
import Dialog from "@/components/Dialog"

class AccountApplyModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      reason: "",
    }
  }

  handleReason = (e) => {
    this.setState({
      reason: e.target.value,
    })
  }

  render() {
    const { reason, disabled } = this.state
    return (
      <Dialog disabled={disabled} className="CreateActionRecordModal" title="填写申请理由" style={{ width: 640 }} {...this.props} onSubmit={this.onSubmit}>
        <FormGroup className="required with-textarea">
          <label style={{ marginBottom: "6px" }}>申请理由:</label>
          <textarea id={"reason"} className="spaui-input" minLength={3} value={reason} onChange={this.handleReason} />
        </FormGroup>
      </Dialog>
    )
  }

  onSubmit = () => {
    const { reason } = this.state
    const { applyStatus, data = {} } = this.props
    const { orderId: order_id, leadId: lead_id, agencyId: agency_id, lead = {} } = data
    if (!reason) return
    this.setState({ disabled: true })
    let params = {}
    let request = ""
    if (applyStatus === "update") {
      params = {
        registration_ticket_id: lead.lastRegistrationTicketId,
        memo: reason,
      }
      request = "updateSelfOpen"
    } else {
      params = {
        order_id,
        lead_id,
        agency_id,
        memo: reason,
      }
      request = "createSelfOpen"
    }
    this.handleRequest(params, request)
  }

  handleRequest = (params, request) => {
    const { webApi } = this.props
    const func = webApi[request]
    func()
      .ajaxJson({
        data: params,
      })
      .then(
        (res) => {
          if (res) {
            this.context.success("成功")
            this.props.onSubmit && this.props.onSubmit()
            this.setState({ disabled: false })
          }
        },
        (error) => {
          this.context.error("失败", error.message)
          this.setState({ disabled: false })
        }
      )
  }
}

export default withApi(AccountApplyModal)
AccountApplyModal.contextType = MessageBox
